export default {
sets: `Conjuntos`,
stats: `Estatisticas`,
discover: `Descobrir`,
guides: `Guias`,
settings: `Definições`,
unsupportedBrowserBody: `Flashcards não suporta este navegador. Faça o download da versão mais recente do Chrome ou Opera, ou faça o download do nosso aplicativo iPhone ou Android`,
unsupportedBrowserTitle: `Navegador não suportado`,
noData: `Sem dados para mostrar`,
contactUsTitle: `Adoramos ouvir como nossos usuários usam nosso aplicativo e como podemos melhorar. Deixe -nos uma mensagem com qualquer dúvida, como solicitações de recursos ou relatórios de bug`,
rateAppStore: `Taxa na AppStore`,
rateGoogle: `Avaliação no Google Play`,
close: `Perto`,
shareFriends: `Compartilhe com amigos`,
noCardsQ: `Não tem flashcards?`,
noCardsS: `Selecione em nossa coleção para começar`,
suggestSet: `Sugerir conjunto`,
createOwn: `Crie seu próprio`,
search: `Procurar`,
loading: `Carregando`,
words: `Palavras`,
downloads: `Transferências`,
export: `Exportar`,
import: `Importar`,
importing: `Importando ... Não feche o aplicativo`,
importPreview: `Importar visualização`,
howQuizlet: `Como importar do Quizlet`,
cards: `Cartões`,
importPreviewStatus: `__ Termos estão prontos para serem anexados aos cartões ___ existentes`,
importPaste: `Cole suas cartas na textarea acima`,
setTotalLimitReached: `Você só pode ter 3000 cartas em um Studyset`,
studying: `Estudo`,
learnt: `Aprendido`,
mastered: `Dominado`,
new: `Novo`,
noTerm: `Sem termo`,
noDef: `Nenhuma definição`,
cardSaved: `Cartão salvo`,
reviews: `Avaliações`,
practices: `Práticas`,
flashcards: `Flashcards`,
alerts: `Alertas`,
corrects: `Corrige`,
mistakes: `Erros`,
reviewCycle: `Ciclo de revisão`,
reviewsLeft: `Revisões restantes`,
lastReview: `Última revisão`,
nextReview: `Próxima revisão`,
hideHistory: `Esconder a história completa`,
showHistory: `Mostre história completa`,
strength: `Força`,
star: `Estrela`,
image: `Imagem`,
tag: `Marcação`,
added: `adicionado`,
removed: `removido`,
reviewedFrom: `Revisado de __`,
notifications: `Notificações`,
reviewedPractice: `Revisado __ por ___ prática`,
successfully: `com sucesso`,
unsuccessfully: `sem sucesso`,
termUpdated: `Termo atualizado`,
defUpdated: `Definição atualizada`,
flashcardCreated: `Flashcard criado`,
dropboxImage: `Você precisa ativar o Dropbox Sync para adicionar imagens`,
deleteImgConfirm: `Tem certeza de que deseja apagar esta imagem?`,
uploading: `Enviando`,
save: `Salve `,
uploadImageFail: `Falha ao fazer upload da imagem`,
imageUploaded: `Imagem carregada`,
setNotFound: `Studyset não encontrado!`,
notEnoughCards: `Cartões insuficientes!`,
of: `__ de ___`,
on: `Em`,
off: `Fora`,
auto: `Automático`,
manual: `Manual`,
pronounce: `Pronunciar`,
practiceCompleted: `Você completou esta prática`,
closePractice: `Prática próxima`,
autoplay: `Reprodução automática`,
secFlipSecNext: `__ Sec Flip, ___ seg`,
autopronounce: `AutoPronounce`,
onlyTerm: `Apenas termo`,
onlyDef: `Apenas definição`,
termAndDef: `Termo e definição`,
savePractice: `Salvar a prática?`,
continueLater: `Continue mais tarde`,
deletePractice: `Excluir prática`,
term: `Prazo`,
def: `Definição`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Revisão da meta`,
dailyGoal: `Objetivo diário`,
edit: `Editar`,
setUp: `Configuração`,
noRecentPractice: `Você não tem práticas recentes`,
continueLastReview: `Continue a última revisão`,
dueCards: `Cartões devido`,
studyNow: `Estude agora`,
newCards: `Novos cartões`,
terms: `termos`,
defs: `definições`,
validCardsOf: `Somente __ dos cartões ___ selecionados podem ser praticados, pois os outros estão perdendo o termo ou a definição`,
reviewCards: `Cartões de revisão`,
customizePractice: `Personalize a prática`,
next: `Próximo`,
iWasRight: `eu tinha razão`,
printProAlert: `Por favor, compre assinatura profissional para imprimir mais de 20 flashcards`,
print: `Impressão`,
printWidth: `Largura da defesa de termo`,
printFont: `Tamanho da fonte`,
printBorder: `Fronteira`,
printMargin: `Margem de página`,
printPadding: `Preenchimento de palavras`,
preparingFile: `Preparando o arquivo`,
notificationsBlocked: `As notificações não estão ativadas, você ativa as notificações das configurações do seu telefone`,
ranOutOfWords: `Ficou sem cartas, reinicie a prática para começar de novo`,
ranOutOfWordsShort: `Ficar sem palavras`,
ranOutOfWordsBody: `Abra o aplicativo para agendar novas palavras`,
proIncreaseNotifications: `Você pode aumentar as notificações totais de 10 para 50 na versão premium.`,
schedule: `Cronograma`,
frequency: `Frequência`,
mode: `Modo`,
tM1: `1 minuto`,
tM2: `2 minutos`,
tM5: `5 minutos`,
tM10: `10 minutos`,
tM15: `15 minutos`,
tM30: `30 minutos`,
tH1: `1 hora`,
tH2: `2 horas`,
termPassive: `Termo passivo`,
termActive: `Termo ativo`,
defPassive: `Def passivo`,
defActive: `Def ativo`,
scheduledIn: `Programado em __ minutos`,
scheduledAlertsProT: `Aumentar alertas programáveis ​​com Pro`,
scheduledAlertsProB: `Você pode aumentar os alertas programados de 10 para 50 com o pacote Pro`,
seeFeatures: `Veja os recursos`,
defAndTerm: `Definição e termo`,
termHoldDef: `Termo, retenha para revelar a definição`,
defHoldTerm: `Definição, segure para revelar o termo`,
notificationType: `Tipo de notificação`,
copyToClipboard: `Copiar para área de transferência`,
enterAuthCode: `Por favor, insira seu código de autorização`,
invalidCode: `Código inválido fornecido`,
copied: `Copiado!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Toque para descobrir todos os recursos premium para aprender com mais eficiência em seu próprio ritmo`,
promoBtn: `Descubra todos os recursos`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Ative o Dropbox Sync para manter seus conjuntos, cartões de flash, tags e progresso backup e atualizado em todos os seus dispositivos.`,
setDropboxPOn: `Seus dados são backup e sincronizados em seus dispositivos.`,
setDropboxBtn: `Sincronizar`,
status: `Status`,
syncNow: `Sincronize agora`,
contact: `Contato`,
contactUs: `Entre em contato conosco`,
useFromBrowser: `Use do navegador`,
useFromBrowserMsg: `Visite FlashCardsMadesimple.com no seu computador e restaure seus cartões e licença, ativando o Dropbox Sync`,
termsPrivacy: `Termos e privacidade`,
dailyReviewGoal: `Objetivo diário de revisão`,
numberTerms: `Número de termos`,
selectTerm: `Selecione com dica de termo`,
selectDef: `Selecione com dica de definição`,
pronounceTerm: `Pronuncie com dica de termo`,
pronounceDef: `Pronuncie com dica de definição`,
typeTerm: `Digite com dica de termo`,
typeDef: `Digite com dica de definição`,
quizTypes: `Tipos de teste preferidos`,
spacedRepetition: `Cronograma de repetição espaçada`,
spacedRepetitionP: `A repetição espaçada permite dominar as palavras com menos esforços, espaçando o tempo de revisão. O cronograma padrão é de 1-3-7-15-31 dias, mas você também pode configurar um personalizado.`,
spacedRepetionScheduleItem: `__ dias após ___ revisão (dia ____)`,
atLeastOneSchedule: `Pelo menos um cronograma é necessário`,
revisionLimitReached: `Você atingiu a contagem máxima de revsisão`,
addReviewSchedule: `Adicionar nova programação de revisão`,
autoMarkLearnt: `Auto Mark aprendeu depois`,
autoMarkMastered: `Mark automático dominou depois`,
tagManager: `Gerenciador de tags`,
delete: `Excluir`,
addTag: `Adicione nova tag`,
tagDeletionH: `Exclusão de tags`,
tagDeletionP: `Tem certeza de que deseja excluir esta tag?`,
cancel: `Cancelar`,
daysAfterLastReview: `Dias após a última revisão`,
linkDropbox: `Link Dropbox`,
startSync: `Iniciar a sincronização`,
starred: `Estrelou`,
images: `Imagens`,
tags: `Tag`,
types: `Tipos`,
activeDays: `Dias ativos`,
inactiveDays: `Dias inativos`,
longestStreak: `Faixa mais longa`,
dailyGoalsCompleted: `Metas diárias concluídas`,
dailyGoalsFailed: `Os objetivos diários falharam`,
typePairs: `Pares de tipos`,
reviewTypes: `Tipos de revisão`,
typePractice: `Tipo prática`,
pronouncePractice: `Pronunciar prática`,
selectPractice: `Selecione Prática`,
notificationReview: `Revisão de notificação`,
flashcardReview: `Flashcard Review`,
studyset: `Studyset`,
enterStudysetName: `Por favor, insira um nome para o seu Studyset`,
studysetName: `Digite o nome do set`,
termType: `Tipo de termo / lang`,
defType: `Tipo de definição / lang`,
exportCards: `Cartões de exportação`,
importCards: `Cartões de importação`,
quiz: `Questionário`,
showingOutOfCards: `Mostrando __ de ___ cartões`,
showingAllCards: `Mostrando todos os cartões, digite a barra de pesquisa acima ou toque em qualquer tags para filtrar`,
recording: `Gravação`,
downloadSet: `Adicionar aos meus sets`,
addNewCard: `Adicione um novo cartão`,
saveStudyset: `Salvar o conjunto de estudos`,
studysetDeletionH: `Exclusão do Studyset`,
studysetDeletionP: `Tem certeza de que deseja excluir este Studyset, isso também excluirá todos os cartões contidos.`,
cardDeletionH: `Exclusão de cartões`,
cardDeletionP: `Tem certeza que deseja excluir este cartão`,
cardLimitReached: `Você só pode ter 3000 cartas em um Studyset`,
limitExceeded: `Limite excedido`,
atLeastTenCards: `Adicione pelo menos 10 cartões para começar com as práticas`,
searchInAll: `Pesquise em todos os conjuntos de estudos`,
noMatch: `Sem correspondência`,
atLeastThreeChars: `Insira pelo menos 3 caracteres para pesquisar`,
noSets: `Sem conjuntos`,
startingSync: `Sincronização inicial`,
noSetsP: `Selecione nas opções abaixo para começar`,
startingSyncP: `Estamos recebendo seus dados do Dropbox, isso pode demorar um pouco`,
createNewStudyset: `Crie um novo Studyset`,
restoreFromBackup: `Restaurar do arquivo de backup`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Selecione Tipo de prática`,
noDueCards: `Ainda não há flashcards de vencimento, os flashcards que você revisou antes começarão a aparecer aqui após o cronograma de repetição espaçado para ajudá -lo a dominar as palavras com menos esforço e tempo`,
noNewCards: `Não há novos cartões para estudar`,
subscriptionH: `Compre Pro para aproveitar todos os recursos e apoiar o desenvolvimento contínuo.`,
buyLifetimePro: `Compre Lifetime Pro para __`,
restorePurchase: `RESTAURAR COMPRA`,
termsPrivacyC: `Termos e Política de Privacidade`,
licenceShare: `Se você comprou uma licença de outro dispositivo, poderá compartilhá -lo com este dispositivo, ativando o Dropbox Sync em ambos os dispositivos`,
enterTagName: `Digite o nome da tag`,
invalidName: `Nome inválido`,
create: `Criar`,
name: `Nome`,
tagName: `Nome da sua etiqueta`,
color: `Cor`,
back: `Costas`,
rowSeparator: `Separador de linha`,
termDefSeparator: `Termo - Def separador`,
output: `Saída`,
inputCards: `Cartões de entrada`,
review: `Análise`,
language: `Linguagem`,
archiveReversible: `Arquivo (reversível das configurações)`,
deletePermanent: `Excluir (irreversível)`,
archivedCards: `Cartões arquivados`,
masteredCards: `Cartões masterizados`,
due: `Vencimento`,
reviewed: `Revisado`,
markReviewed: `Mark revisado`,
markMastered: `Mark dominou`,
forXYCards: `para __ ___ cartões`,
createdAtSortBy: `Data de criação`,
lastReviewedSortBy: `Última data de revisão`,
reviewCountSortBy: `Número de revisões`,
strengthSortBy: `Força`,
termSortBy: `Termo alfabético`,
definitionSortBy: `Def.`,
ascSortBy: `Ascendente`,
descSortBy: `descendente`,
featureSync: `Estude qualquer coisa, em qualquer lugar, a qualquer hora com seus cartões de flash sincronizados em todos os seus dispositivos`,
featureSpacedrepetition: `Olhe para o seu progresso geral e volte a praticar o que você precisa para praticar`,
featureNotifications: `Sobrecarregar seu aprendizado sem sequer abrir o aplicativo com notificações flexíveis`,
featureFlashcards: `AutoPlay Flashcards quando suas mãos ou olhos estão ocupados, mas você ainda tem atenção não utilizada`,
featureQuiz: `Combine, solete, ouça ou selecione Praticar seus flashcards`,
featureStats: `Obtenha uma melhor visão sobre seus cartões e resultados e pesquise em todos os seus conjuntos de cartões flash`,
featureImport: `Nunca armazenaremos nenhum dado de você e você pode exportar e importar todos os seus dados facilmente`,
featurePrint: `Faça algum aprendizado imprimindo seus cartões de inflamação e DIY sua própria plataforma de estudo`,
splashIntro: `Estude todos os seus flashcards em qualquer lugar do seu ritmo e estilo`,
selectSortOrder: `Ordem de classificação`,
selectSortProp: `Classificar propriedade`,
applyFilters: `Aplicar filtros`,
selectSetType: `O que você quer praticar?`,
getStarted: `Iniciar`,
tapToUnarchive: `Toque nos cartões que deseja que você`,
untitled: `Sem título`,
sortHintNew: `você verá os cartões que foram criados mais tempo atrás primeiro`,
sortHintDue: `você verá cartões que foram devido ao primeiro mais longo`,
sortHintOther: `você verá cartões que não foram estudados o primeiro mais longo`,
flashcardsWhen: `, quando suas mãos ou olhos estão ocupados, mesmo ouvindo músicas / podcasts`,
notificationsWhen: `, para quando você está fora de casa e só quer um estudo rápido`,
quizWhen: `, para quando você pode prestar atenção total para estudar, para dominar seus cartões`,
features: `Recursos`,
ratings: `Classificações`,
notificationDailyCatchUpBody: `NOVO: __, devido: ___, estudando: ____, aprendido: _____, dominado: ______`,
notificationDailyCatchUpTitle: `Captura diária`,
reviewedJN: `Revisado agora`,
customUpdated: `Texto personalizado atualizado`,
customTextField: `Sinônimos, exemplos, etc.`,
field: `Campo`,
link: `Link`,
backToParentCard: `Voltar para o cartão -mãe`,
discard: `Descartar`,
failedImageLoad: `Falha ao carregar a imagem, verifique se você está conectado à Internet`,
printDIYLabel: `DIY sua própria configuração de estudo baseada em papel criativo, compartilhe conosco sua criação e apareça no aplicativo.`,
reviewGraphChart: `Frequência de revisão`,
langNotSet: `Idioma não definido`,
pronouncationLangInfo: `Para ativar a pronúncia, você deve selecionar o termo e a linguagem de definição. Um sinal de alto -falante aparecerá ao lado dos idiomas se o seu dispositivo suportar esse idioma`,
clearFilters: `Filtro limpo`,
subFreeUnlimited: `Estudos ilimitados, cartões de memória flash, práticas, pesquisa e sincronização`,
customFields: `Os campos personalizados`,
subLinks: `Links de cartão`,
subPrint: `Imprimir / Studyset`,
subNotifications: `Notificação antes de ter que abrir o aplicativo`,
subCardsStudysets: `Cartões / studyset`,
subRevisionCycles: `Ciclos de revisão personalizados`,
subscriptionHEnd: `A atualização para o Pro mostra que você achou nosso trabalho duro valioso e nos dá incentivo e café para continuar melhorando e criando novas coisas incríveis.`,
subFree: `Livre`,
subPro: `Pró`,
guideSpacedRepetition: `Como os tipos de trabalho e prática de repetição espaçados`,
guideSearch: `Pesquisa e filtragem`,
guideSync: `Ativar backup e sincronização em seus dispositivos`,
guidePronunciation: `Ativar pronúncias`,
guideImport: `Importando cartões de fontes de saída`,
guideAccess: `Quem tem acesso aos meus dados?`,
guideData: `Que dados coletamos?`,
guideContact: `Precisa de ajuda com mais alguma coisa? Escreva para nós`,
arrowStrength: `Defina o quão bem você conhece este cartão`,
arrowImage: `Adicionar imagens`,
arrowField: `Adicione campos de texto personalizados adicionais`,
arrowTag: `Anexe tags`,
arrowStar: `Marque como favorito`,
arrowLink: `Link para outros cartões`,
arrowGoal: `Configure uma meta de revisão diária para você`,
arrowDue: `Estude as palavras que devem ser revisadas`,
arrowNew: `Cartões de estudo que ainda não foram revisados`,
arrowMastered: `Se você não tiver cartões de vencimento ou novos, pode revisar os cartões masterizados para mantê -los dominado`,
arrowImport: `Importe seus flashcards existentes`,
arrowNewCard: `Adicione um novo flashcards`,
dropboxStep1: `1. Obtenha o código de acesso do Dropbox fazendo login`,
dropboxStep1Btn: `Faça login com o Dropbox`,
dropboxStep2: `2. Digite o código de acesso abaixo`,
dropboxStep2Input: `Entre com o código aqui`,
dropboxStep3: `3. Inicie a sincronização`,
alreadyLinked: `Já vinculado, toque para desvincular`,
selectCardsToLink: `Selecione cartões para vincular`,
unsupportedLangP: `Selecione um idioma que suporta pronunciação nas configurações do conjunto`,
links: `Links`,
emailUs: `Envie-nos um e-mail`,
whatsappUs: `Whatsapp US`,
printMinHeight: `Min. altura da linha`,
exportType: `Exportar tipo de arquivo`,
generateFileText: `Gerar arquivo`,
generatatingFile: `Geração de arquivo`,
verySmall: `Muito pequeno`,
small: `Pequeno`,
normal: `Normal`,
big: `Grande`,
veryBig: `Muito grande`,
repeatNTimes: `Repita __ vezes`,
pause: `Pausa`,
for: `por`,
say: `Dizer`,
defShort: `Defin.`,
times: `vezes`,
autoplayPreferences: `Defina as preferências da AutoPlay`,
autoPlay1: `Pausa após a palavra anterior`,
autoPlay2: `Número de pronunciações a termos`,
autoPlay3: `Pausa antes de revelar a definição`,
autoPlay4: `Número de pronunciações de definição`,
autoPlay5: `Pausa antes de mostrar a próxima palavra`,
autoPlay6: `Repita o mesmo cartão de flash`,
startAutoPlay: `Inicie o AutoPlay`,
autoPlayOffConfirm: `Desligue o AutoPlay para ativar os controles manuais`,
turnOff: `Desligar`,
keepPn: `Continuar`,
foundIn: `Encontrado em __`,
repeat: `repetir`,
stop: `Pare`,
listenInBreak: `Você sabia? Você pode ouvir música / podcasts em breaks`,
contextSearch: `Pesquisa de contexto`,
contextSearchText: `Obtenha exemplos de como __ usado em frases diferentes`,
transalteSearch: `Traduzir`,
translateSearchText: `Traduza para ___`,
synonymSearch: `Pesquisa de sinônimo`,
synonymSearchText: `Procure sinônimos de __`,
selectToAdd: `Selecione os resultados que deseja adicionar a este cartão`,
addToCard: `Adicionar selecionado ao cartão`,
hideFromPractice: `Esconda -se em volta`,
setLanguageRequired: `Selecione o idioma dos termos e definições nos detalhes do Studyset`,
fieldNeedsText: `Insira algo neste campo antes de pesquisar`,
possibleDupe: `Possível duplicado`,
loadNextXCards: `Carregar os próximos cartões __`,
repeatPractice: `Repita estes __ cartões`,
keepScreenOnInfo: `Pode ser necessário ajustar sua configuração de trava automática, para manter a tela ativada durante a realização automática.`,
siteLoginH2: `Conta SFM`,
siteLoginP: `Você pode usar seus cartões de memória flashes simples para compartilhar seus cartões de memória com seus amigos, alunos ou toda a comunidade.`,
logOut: `Sair`,
logIn: `Conecte-se`,
createAccount: `Criar nova conta`,
signUp: `Inscrever-se`,
username: `Nome do usuário`,
email: `E-mail`,
password: `Senha`,
networkError: `Erro de rede`,
fillAllDetails: `Por favor, preencha todos os detalhes`,
noUserWithDetails: `Nenhum usuário encontrado com os detalhes inseridos`,
userAlreadyExists: `O e -mail ou nome de usuário fornecido já existe`,
signUpOrLoginToCont: `Inscreva -se ou faça login para continuar?`,
atLeastOneCardToShare: `Pelo menos uma carta é necessária para compartilhar`,
publishingStudyset: `Publicação Studyset`,
updatesDetected: `Atualizações detectadas, você deseja prosseguir a atualização de dados locais? (Excluído: __, atualizado: ___, novo: ____)`,
updatesApplied: `Atualizações aplicadas`,
alreadyUpToDate: `Já atualizado`,
practiceTypeArrow: `Descubra diferentes maneiras de pracitar`,
share: `Compartilhar`,
sharingModalIntro: `Compartilhe seus flashcards neste conjunto com seus amigos, seus alunos ou toda a comunidade.`,
whatIsShared: `O que é compartilhado`,
whatIsNotShared: `O que não é compartilhado`,
whatIsSharedText: `Defina o nome, defina o idioma de termo, linguagem definitiva, todos incluídos cartões com termos, definições, campos de texto personalizados e imagens`,
whatIsNotSharedText: `Qualquer cartão de cartão, estrelas, links, tags e seu histórico de revisão`,
checkForSharedUpdates: `Verifique se há atualizações do Criador`,
fetchUpdates: `Buscar atualizações`,
youSharedStudyset: `Você compartilhou este Studyset`,
publishChanges: `Salvar e publicar mudanças`,
redeem: `Resgatar`,
noAds: `Sem anúncios`,
dupeDetection: `Detecção duplicada`,
coffeeFeature: `Café, para nos ajudar a desenvolver mais recursos`,
shareLink: `Compartilhar link`,
coffeeForUs: `Você obterá uma licença vitalícia por apenas __, que dá a Emily 6 cafés, Dominik 3 cafés e Russ 3 Coffees, que nos abastecerão por cerca de 39 horas para melhorar este evento do aplicativo`,
sharingCards: `Compartilhando cartões`,
published: `Publicados`,
alreadyHaveAccount: `já tem uma conta?`,
notAlreadyHaveAccount: `Não tem uma conta ainda?`,
startPractice: `Comece a praticar`,
selectQuizTypes: `Selecione Tipos de Quiz`,
correct: `Correto`,
incorrect: `Incorreta`,
yes: `Sim`,
no: `Não`,
levelSilver: `Nível de prata __`,
levelGold: `Nível de ouro __`,
levelPlatinum: `Nível de platina __`,
levelDiamond: `Nível de diamante __`,
levelJade: `Nível de jade __`,
reviewsLeftGoal: `__ Revisões para meta diária`,
dailyGoalAchieved: `Objetivo diário alcançado`,
share: `Compartilhar`,
rateApp: `App de taxa`,
allStats: `Todas as estatísticas`,
reviewTimeError: `Tempo limite após erro`,
reviewTimeCorrect: `Tempo limite após correto`,
pronounceTermAfterReview: `Pronunciar termo após revisão`,
pronounceDefinitionAfterReview: `Pronuncie definição após revisão`,
practice: `Prática`,
notificationsScheduledInfo: `__ Notificações foram agendadas, você pode fechar o aplicativo agora`,
wellDone: `Bom trabalho`,
keepItUp: `Mantem`,
youRock: `Você é demais`,
niceOne: `Agradável`,
lnSelect: `Selecione o idioma`,
sampleData: `Sem críticas, mostrando dados de amostra`,
reviewFreq: `Frequência de revisão`,
selectPractice: `Prática: selecione`,
spellPractice: `Prática: feitiço`,
connectPractice: `Prática: Conecte`,
languages: `línguas`,
languagesPairs: `Pares de idiomas`,
shareArrow: `Compartilhe set com amigos, alunos ou toda a comunidade`,
cardsPerRound: `Cartões / rodada`,
showAll: `Mostre tudo`,
supportedLangsVary: `Os idiomas suportados variam`,
practiceWithoutSave: `Prática não salva`,
practiceWithoutSaveBody: `Você não adicionou este Studyset à sua coleção, quer adicioná -la agora para salvar o progresso do seu estudo?`,
saveSetNow: `Salvar cartões para você coleção`,
continueWithoutSaveSave: `Comece a praticar sem salvar`,
createdBy: `Criado por`,
setSavedToYourCollection: `Conjunto de estudos salvo em sua coleção`,
accountBackupDisclaimer: `Observe que esta conta só pode ser usada para compartilhar Studysets com outras pessoas e não pode ser usada para fazer backup ou sincronizar seus Studysets ou FlashCards. Para sincronizar e fazer backup de todos os seus dados, use o Dropbox Sync`,
syncEnabled: `A sincronização permitiu, buscando seu conteúdo em andamento`,
searchAllSets: `Pesquisar conjuntos de estudos de outros usuários`,
anyLanguage: `Qualquer língua`,
trendingIn: `Tendência para dentro`,
manualBackups: `Backup manual`,
manualBackupCreate: `Crie backup manual`,
confirmManualImport: `Tem certeza de que deseja substituir todos os dados atuais por este backup? Isso é recomendado apenas em novos dispositivos sem dados`,
importFromManualBackup: `Importação do backup`,
imgOfflineSets: `Imagens de download automático para aprendizado offline`,
unsupportedDeviceCache: `Este recurso está disponível apenas no aplicativo iOS ou Android`,
shareChanges: `Compartilhar __ mudanças`,
publiclySearchable: `Pesquisável por usuários`,
description: `Descrição`,
restoreFromDropboxBackup: `Restaurar do backup do Dropbox`,
imageCacheStudysetSub: `[apenas iOS e apenas Android] Baixe a imagem para estudar offline`,
keywordsOrLangNeeded: `Você tem que inserir algumas palavras -chave ou um idioma`,
dropboxAlreadyLinked: `A conta do Dropbox já está vinculada`,
noSetUpdateAccess: `Você não tem acesso para editar este conjunto de estudos.`,
confirmSetOwnerLogin: `Se você tem certeza de que é o proprietário, tente fazer login na sua conta novamente.`,
uninitedRestriction: `Para salvar seu progresso, primeiro você deve adicionar este Studyset à sua coleção`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Falha ao consolidar o armazenamento`,
consolidateStorageDone: `Consolidar o armazenamento, aguarde até uma hora para o Dropbox terminar de remover arquivos antigos antes de fazer login em um novo dispositivo.`,
consolidatingStorage: `Consolidação de armazenamento ...`,
deleteAccount: `Deletar conta`,
consolidateStorageDescription: `Esta operação irá reindicar seus arquivos de backups; portanto, a configuração de novos dispositivos será mais rápida`,
consolidatingStorageConfirm: `Certifique -se de que todas as suas alterações já tenham terminado de sincronizar, não sincronize outros dispositivos enquanto esse processo estiver ocorrendo. Você quer continuar?`,
consolidateStorage: `Consolidar armazenamento`,


}